
import { DataGrid} from "@mui/x-data-grid";
import { Box, CircularProgress } from "@mui/material";



const CustomDataGrid = ({ rows, columns, isLoading }) => {
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={300}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <DataGrid
      rows={rows}
      columns={columns}
    //   disableRowSelectionOnClick
      pageSizeOptions={[10, 25, 50, 100]}
      pagination
    //   getRowHeight={() => "auto"}
        experimentalFeatures={{ columnGrouping: true }}
      sx={{
        border: "none",
        boxShadow: "none",
        backgroundColor: "transparent",

        "& .MuiPaper-root": {
          boxShadow: "none !important",
          backgroundColor: "transparent",
        },
        "& .MuiDataGrid-main": {
          boxShadow: "none !important",
        },
        "& .MuiDataGrid-columnHeaders": {
          border: "none",
          borderBottom: "none",
          backgroundColor: "#F9F9F9",
          color: "primary.main",
          fontWeight: "bold",
          fontSize: "0.8rem",
        },
        "& .MuiDataGrid-columnHeader": {
          border: "none",
           backgroundColor: "#F9F9F9 !important",
        },
        "& .MuiDataGrid-columnHeader:last-of-type": {
          borderRight: "none",
        },
        "& .MuiDataGrid-cell": {
          border: "none",
          color: "#333",
          fontWeight: 400,
          fontSize: "0.95rem",
        },
        "& .MuiDataGrid-cell:last-of-type": {
          borderRight: "none",
        },
        "& .MuiDataGrid-row:nth-of-type(even)": {
          backgroundColor: "#F9F9F9",
        },
        "& .MuiDataGrid-row:nth-of-type(odd)": {
          backgroundColor: "#FFF1F1",
        },
        ".MuiDataGrid-cell, .MuiDataGrid-columnHeader": {
          outline: "none",
        },
      }}
    />
  );
};

export default CustomDataGrid;
